import { useState, MouseEventHandler, ReactNode } from 'react';

import { Menu } from '@mui/material';
import { CirclePicker } from 'react-color';

import { DEFAULT_COLORS } from '../../InteractiveMapControl/MapConfigCreator/controls/ColorPicker';

type ChartColorPickerProps = {
    color?: string;
    onColorChange?: (color: string) => void;
    onClose?: () => void;
    button?: (onClick?: MouseEventHandler<HTMLElement>) => ReactNode;
};

export const ChartColorPicker = ({
    color,
    onClose = () => undefined,
    onColorChange = () => undefined,
    button = () => undefined,
}: ChartColorPickerProps): JSX.Element => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleMenuClick: MouseEventHandler<HTMLElement> = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = (): void => {
        setAnchorEl(null);
        onClose();
    };

    return (
        <>
            {button(handleMenuClick)}
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => {
                    handleClose();
                }}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                PaperProps={{
                    sx: {
                        p: 2,
                    },
                }}
            >
                <CirclePicker
                    styles={{
                        default: {
                            card: {
                                background: 'none',
                            },
                        },
                    }}
                    color={color}
                    onChangeComplete={(c) => {
                        onColorChange(c.hex);
                        handleClose();
                    }}
                    colors={DEFAULT_COLORS}
                />
            </Menu>
        </>
    );
};
